import { useContext, useEffect, useState } from "react";
import { useController } from "react-hook-form";
import NoResult from "./NoResult";
import { FormContext } from "components/shared/Form";
import {
  SelectAutocomplete,
  SelectAutocompleteTextField,
} from "components/ui/atoms/SelectAutocomplete";

const ListSelectField = ({
  options,
  name,
  label,
  multiple,
  onChange: onChangeOriginal,
  ...props
}) => {
  const {
    form: { control },
  } = useContext(FormContext);
  const {
    field: { ref, value, onChange, ...otherFields },
    fieldState,
  } = useController({
    control: control,
    name: name,
  });
  const [optionsDictionary, setOptionsDictionary] = useState(undefined);

  const handleChange = (data) => {
    onChange(data);
    onChangeOriginal && onChangeOriginal(data);
  };

  useEffect(() => {
    if (options) setOptionsDictionary(Object.fromEntries(options));
  }, [options]);

  if (!optionsDictionary) return <></>;

  // debug is much easier with this log
  if (value === null)
    console.error(
      `DictionaryField [name=${name}] value equal to null. If you mean no value, it should be "" or [] if multiple`,
    );

  return (
    <SelectAutocomplete
      {...otherFields}
      value={value === "" ? (multiple ? [] : null) : value}
      onChange={(event, data) => {
        let new_data = data === null ? (multiple ? [] : "") : data;
        if (Array.isArray(new_data)) new_data.sort();
        handleChange(new_data);
      }}
      onInputChange={(event, data) => {
        if (props.freeSolo && !multiple) {
          handleChange(data);
        }
      }}
      multiple={multiple}
      options={options.map((v) => v[0])}
      noOptionsText={<NoResult />}
      getOptionLabel={(optionId) =>
        optionsDictionary[optionId] || `${optionId}`
      }
      renderInput={(params) => (
        <SelectAutocompleteTextField
          {...params}
          helperText={fieldState.error?.message}
          error={fieldState.invalid}
          label={label}
        />
      )}
      isOptionEqualToValue={(option, value) => option == value}
      {...props}
    />
  );
};

export default ListSelectField;
